import React from 'react'

import Text from 'components/typo/Text'
import Button from '../Button'

import classnames from 'classnames/bind'
import css from './styles.module.scss'
import Image from 'components/shared/Image'

const cx = classnames.bind(css)
const FeatureCard = ({
  icon,
  title,
  text,
  button,
  image,
  index,
  upperTitle,
  features,
  isHomePage,
}) => {
  const isButton = button && button.text && button.href
  return (
    <div
      className={cx(css.dynamicCardWrapper, {
        [css.padding]: isHomePage,
      })}
    >
      <div
        className={cx(css.wrapper, {
          [css.flexRow]: index === 0,
          [css.flexRowReverse]: index === 1,
        })}
      >
        <div className={cx(css.leftSide, css.justifyContentTop)}>
          <div className={css.header}>
            <div
              className={cx(css.titleRow, {
                [css.alignCenter]: !upperTitle,
              })}
            >
              {index < 3 && (
                <Image
                  className={css.dynamicIcon}
                  media={{ width: 32, height: 32 }}
                  fluid
                  {...icon}
                  alt={
                    icon?.media?.data?.attributes?.alternativeText ??
                    'icon-image'
                  }
                  notAbsolute
                />
              )}
              <div>
                {upperTitle && (
                  <Text className={css.upperTitle}>{upperTitle}</Text>
                )}
                <Text className={css.dynamicCardTitle}>{title}</Text>
              </div>
            </div>
            <Text
              className={cx(isHomePage ? css.descriptionBlue : css.description)}
            >
              {text}
            </Text>
            {isButton && (
              <Button
                theme="white"
                className={css.btn}
                href={button.href}
                buttonClassName={css.button}
                target={button.target ?? 'blank'}
              >
                <span>{button.text}</span>
              </Button>
            )}
            {isButton && !upperTitle && (
              <Button
                theme="link"
                className={css.linkBtn}
                href={button.href}
                target={button.target ?? 'blank'}
              >
                <span>{button.text}</span>
              </Button>
            )}
          </div>
        </div>
        <Image
          className={css.image}
          media={{ width: 32, height: 32 }}
          fluid
          {...image}
          alt={image?.media?.data?.attributes?.alternativeText ?? 'card-image'}
        />
      </div>
      {features && features.length > 1 && upperTitle && (
        <div className={css.featuresWrapper}>
          {features.map((feature, index) => (
            <OneFeature key={index} {...feature} />
          ))}
        </div>
      )}
    </div>
  )
}

export default FeatureCard

const OneFeature = ({ title, description, icon }) => {
  return (
    <div className={css.oneFeatureWrapper}>
      <div className={css.oneFeatureRow}>
        {icon && (
          <Image
            className={css.oneFeatureIcon}
            media={{ width: 20, height: 20 }}
            fluid
            {...icon}
            alt={icon?.media?.data?.attributes?.alternativeText ?? 'icon-image'}
            notAbsolute
          />
        )}
        <Text className={css.oneFeatureTitle}>{title}</Text>
      </div>
      <Text className={css.oneFeatureDescription}>{description}</Text>
    </div>
  )
}
